<template>

    <dialog class="jsModale jsModale--light" data-modale-id="1">

      <header class="font-bold py-15 px-20 pr-30">
        <p>Le détail de votre offre Forfait
          <span v-if="data_dialogforfait.forfaits && data_dialogforfait.forfaits[forfaitid] && data_dialogforfait.forfaits[forfaitid].field_appels > 0" class="c-orange">{{ data_dialogforfait.forfaits[forfaitid].field_appels}}h </span>
          <span v-if="data_dialogforfait.forfaits && data_dialogforfait.forfaits[forfaitid] && data_dialogforfait.forfaits[forfaitid].field_internet" class="c-orange">{{ data_dialogforfait.forfaits[forfaitid].field_internet}}Go</span>
        </p>
        <button class="jsModaleClose absolute top-0 right-0 w-40 h-40 pointer z-10" type="button" title="Fermer la modale"><span class="sr-only">Fermer la modale</span><span class="c-black dflex-center" aria-hidden="true"><img src="@/assets/images/ico-cross.svg" alt="" /></span></button>
      </header>


      <section class="p-20 relative">
        <div>
          <p class="font-bold text-xl lg:text-22 leading-24 lg:leading-26 mb-35 lg:mb-24">Composition de l'offre</p>
        </div>
        <div v-if="data_dialogforfait.forfaits && data_dialogforfait.forfaits[forfaitid]" class="pb-40 richContent">
          <div v-html="data_dialogforfait.forfaits[forfaitid].field_description_forfait"></div>
        </div>
      </section>

      <!-- <footer></footer> -->

    </dialog>

</template>


<script setup>
import { ref } from 'vue';
import { onMounted, nextTick } from 'vue';

const data_dialogforfait = ref({});
const error_dialogforfait = ref(null);
const isLoading = ref(true);

const props = defineProps({
  data_etape0: Object,
  paragraphId: Number,
  parcours: Object,
  forfaitid: Number,
  tag: Object
});



//defineEmits(['switchToEtape3']);

const emit = defineEmits(['switchToEtape3','enableSelect','loadChooseMultiligne']);


function jsModale() {
  const modale = document.querySelector('.jsModale');
  modale.showModal();
  modale.querySelector('.jsModaleClose').addEventListener('click', closeModale);
  modale.addEventListener('click', e => closeModal(e));

}

function closeModale(e) {
  const modale = e.currentTarget.parentElement.parentElement;
  modale.close();
  e.target.removeEventListener('click', closeModale);
}

function closeModal(e) {
    //console.log('close Modal');
    const modale = document.querySelector('.jsModale');

    const modaleHeader = modale.querySelector('header');
    const modaleContent = modale.querySelector('section');
    const modaleFooter = modale.querySelector('footer');

    modale.querySelector('.jsModaleClose').addEventListener('click', function() {
      //console.log('Croix Modale');
      modale.close();
      modale.removeEventListener('click', closeModal);
    });

    if (modaleHeader.contains(e.target) || modaleContent.contains(e.target)) {
      //console.log('close Modal 1');
      return;
    } else {
      //console.log('close Modal 2');
      modale.close();
      modale.removeEventListener('click', closeModal);
    }
}



onMounted(async () => {
  try {
    const params = new URLSearchParams({
      mobile: props.parcours.mobile,
      multiligne: 0,
      forfaitid: props.forfaitid
    });
    const res = await fetch(`/packopenv3/getforfait?${params}`);
    if (!res.ok) throw new Error(`Erreur HTTP ${res.status}`);
    data_dialogforfait.value = await res.json();
    await nextTick();
    jsModale();
  } catch (e) {
    error_dialogforfait.value = e.message;
  } finally {
    isLoading.value = false;
  }
});



</script>
